import React from 'react';

const navLinks = [
  { href: 'mailto:info@northstarpromo.com', label: 'Mail', icon: '/img/mail.svg' },
  { href: 'https://instagram.com/northstar.musicpromo', label: 'Instagram', icon: '/img/social.svg' },
  { href: 'https://open.spotify.com/playlist/4AFWdbkp18UhE5oIYnuVK8?si=6b10443b895d4172', label: 'Spotify', icon: '/img/spot.svg' },
  { href: 'https://northstarpromo.com', label: 'Website', icon: '/img/link.svg' },
];

function HomeNav() {
  return (
    <nav className="home-nav">
      <div className="home-nav__icons">
        {navLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            target={link.href.startsWith('http') ? '_blank' : undefined}
            rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
            className="home-nav__icon-btn"
            aria-label={link.label}
          >
            <img src={process.env.PUBLIC_URL + link.icon} alt={link.label} className="home-nav__icon" />
          </a>
        ))}
      </div>
      <img src={process.env.PUBLIC_URL + '/img/Northstar_Logo.png'} alt="Logo" className="home-nav__logo" />
    </nav>
  );
}

export default HomeNav; 